import { render, staticRenderFns } from "./EditTabParentAccount.vue?vue&type=template&id=543664c1"
import script from "./EditTabParentAccount.vue?vue&type=script&lang=js"
export * from "./EditTabParentAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports